import React from 'react';
import cn from 'classnames';
import { DH } from '../../utils/DataHook';
import { t } from '../../utils/i18n';
import s from './styles.scss';
import { useSiteStyles } from '../../hooks/useSiteStyles';
import { useSelector } from 'react-redux';
import { selectShouldApplySiteStyles } from '../../redux/selectors';

interface NoPaymentMethodsViewProps {
  isPaymentMethodsConnected: boolean;
  handleRefreshClick(): void;
}

export const NoPaymentMethodsView: React.FC<NoPaymentMethodsViewProps> = ({
  isPaymentMethodsConnected,
  handleRefreshClick,
}) => {
  const { textColor } = useSiteStyles();
  const shouldApplySiteStyles = useSelector(selectShouldApplySiteStyles);
  return (
    <div
      data-hook={DH.NoPaymentsMethods.Container}
      className={cn(s['no-payment-methods'])}
    >
      <div
        className={cn(s['content-row'], s['title-row'])}
        style={shouldApplySiteStyles && textColor ? { color: textColor } : null}
        data-hook={DH.NoPaymentsMethods.Title}
      >
        {t(
          isPaymentMethodsConnected
            ? 'paymentMethods.disabled.title'
            : 'paymentMethods.notConnected.title'
        )}
      </div>
      <div
        className={cn(s['content-row'])}
        style={shouldApplySiteStyles && textColor ? { color: textColor } : null}
        data-hook={DH.NoPaymentsMethods.Content}
      >
        {t(
          isPaymentMethodsConnected
            ? 'paymentMethods.disabled.content'
            : 'paymentMethods.notConnected.content'
        )}
      </div>
      {isPaymentMethodsConnected && (
        <button
          data-hook={DH.NoPaymentsMethods.RefreshButton}
          className={s['no-payment-methods-btn']}
          style={
            shouldApplySiteStyles && textColor ? { color: textColor } : null
          }
          onClick={handleRefreshClick}
        >
          {t('paymentMethods.disabled.refresh')}
        </button>
      )}
    </div>
  );
};

NoPaymentMethodsView.displayName = 'NoPaymentMethodsView';
